export default __webpack_public_path__ + "static/media/microvessel-model.d2caa0d2.png";